var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"chart",attrs:{"id":"D3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }